import type { ApplicantCreation } from 'cpool-schemas';
import type { Path } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LuTrash2 } from 'react-icons/lu';

import { TextInput } from 'cpool-components/input/TextInput';

import { FormCurrencyInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormCurrencyInput';
import { FormPercentInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormPercentInput';
import { getFormErrorMessage } from '~/features/leadDetails/components/Overview/CustomerData/shared/getFormErrorMessage';
import { KONTOKORRENTKREDIT } from '../../../util/types';

type Props = {
    index: number;
    onRemove: () => void;
};

export const KontokorrentKredit: React.FC<Props> = ({ index, onRemove }) => {
    const { t } = useTranslation();
    const {
        control,
        formState: { errors },
        register,
    } = useFormContext<ApplicantCreation>();

    const getArrayFieldErrorMessage = (field: string) =>
        getFormErrorMessage(errors, `${KONTOKORRENTKREDIT}.${index}.${field}` as Path<ApplicantCreation>);

    return (
        <div className="rounded bg-white p-2.5 space-y-3">
            <div className="flex items-center justify-between">
                <h4 className="text-sm font-semibold text-midnight">
                    {`${t(`EXISTING_LOANS.TYPES.${KONTOKORRENTKREDIT}`)} ${index + 1}`}
                </h4>
                <button
                    type="button"
                    onClick={onRemove}
                    className="p-2 text-alert-error hover:bg-alert-error/10 rounded"
                >
                    <LuTrash2 />
                </button>
            </div>

            <div className="grid grid-cols-2 gap-3">
                <FormCurrencyInput
                    id={`${KONTOKORRENTKREDIT}.${index}.verfuegungsrahmen` as Path<ApplicantCreation>}
                    label={t('EXISTING_LOANS.LOAN_FRAME')}
                    control={control}
                    min={0}
                />

                <FormCurrencyInput
                    id={`${KONTOKORRENTKREDIT}.${index}.beanspruchterBetrag` as Path<ApplicantCreation>}
                    label={t('EXISTING_LOANS.LOAN_USED_AMOUNT')}
                    control={control}
                    min={0}
                />

                <TextInput
                    id={`${KONTOKORRENTKREDIT}.${index}.glaeubiger`}
                    label={t('EXISTING_LOANS.LOAN_CREDITOR')}
                    labelClassName="w-[175px] justify-start"
                    error={getArrayFieldErrorMessage('glaeubiger')}
                    {...register(`${KONTOKORRENTKREDIT}.${index}.glaeubiger` as Path<ApplicantCreation>)}
                />

                <FormPercentInput
                    id={`${KONTOKORRENTKREDIT}.${index}.zinssatz` as Path<ApplicantCreation>}
                    label={t('EXISTING_LOANS.LOAN_INTEREST')}
                    control={control}
                    min={0}
                />
            </div>
        </div>
    );
};
